import yogaImg from "../../assets/images/common/yoga.png";
import avtarIcon from "../../assets/images/common/avtar.png";
import filesIcon from "../../assets/images/common/fileicon.png";
import userImg from "../../assets/images/common/usericon.png";
import QrCodeImg from "../../assets/images/common/qrcode.png";
import pdfIcon from "../../assets/images/common/pdficon.png";
import noDataImg from "../../assets/images/common/no-appointments.png";
import RxImg from "../../assets/images/common/RxIcon.png";
import logo from "../../assets/images/layout/sidebarlogo.png";
export const Images = {
  yogaImg,
  avtarIcon,
  filesIcon,
  noDataImg,
  logo,
  userImg,
  QrCodeImg,
  RxImg,
  pdfIcon,
};
